import { Status } from "@bcc-ui/ui-components";
import { TFunction } from "i18next";

import { RiskLevel } from "domain/asset-management/assetFilterConstants";

export const getRiskLevelStatus = (riskLevel?: string): Status => {
    if (riskLevel === RiskLevel.LOW) {
        return Status.SUCCESS;
    }
    if (riskLevel === RiskLevel.MEDIUM) {
        return Status.WARNING;
    }
    if (riskLevel === RiskLevel.HIGH) {
        return Status.ERROR;
    }
    return Status.NEUTRAL;
};

export enum LockState {
    LOCKED = "LOCKED",
    UNLOCKED = "UNLOCKED",
    NOT_AVAILABLE = "NOT_AVAILABLE",
}

export const deduceRiskLevelValue = (t: TFunction, riskLevel?: string) => {
    if (!riskLevel || riskLevel === RiskLevel.NOT_AVAILABLE) {
        return t("Common.na");
    }
    return t("AssetManagement.sidePanel.riskLevel." + riskLevel.toLowerCase());
};
